export const config = {
  MY_API_TOKEN: "AIzaSyDD1_JOR0fBO1jKtP9QzopYp6BlaoRihbs",
  AUTH_DOMAIN: "not-insta-theanuuurag.firebaseapp.com",
  PROJECT_ID: "not-insta-theanuuurag",
  STORAGE_BUCKET: "not-insta-theanuuurag.appspot.com",
  MESSAGING_SENDER_ID: "126900179234",
  APP_ID: "1:126900179234:web:2785f4f5876d1c8737557b",
  MEASUREMENT_ID: "G-1FGN3L3LZR",
};
